import { render, staticRenderFns } from "./JwczbtzcBlock.vue?vue&type=template&id=d3273dfc&scoped=true"
import script from "./JwczbtzcBlock.vue?vue&type=script&lang=js"
export * from "./JwczbtzcBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3273dfc",
  null
  
)

export default component.exports